import { memo, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setChildPageName, setPageName } from '../../../../redux'
import CarsBox from './CarsBox'
import { getData } from '../../../../assets/scripts/GeneralFunctions'

function Cars() {
  const dispatch = useDispatch()
  const [lazy_load_data, setLazyLoadData] = useState({
    limit: 10,
    offset: 0,
  })
  const [cars, setCars] = useState([NaN, NaN])
  const [customer_types, setCustomerTypes] = useState([])
  const [car_models, setCarModels] = useState([])
  const [customers, setCustomers] = useState([])

  useEffect(() => {
    async function fetchData() {
      dispatch(setChildPageName('cars'))
      dispatch(setPageName('cars'))
      let api_result = await getData(
        'admin/cars',
        'get',
        {
          ...lazy_load_data,
        },
        true
      )
      if (api_result) {
        if (api_result?.status === 200) {
          let result_data = api_result?.data
          setCars(result_data?.cars)
          setCarModels(result_data?.car_models)
          setCustomerTypes(result_data?.customer_types)
          setCustomers(result_data?.customers)
          setLazyLoadData({
            limit: 10,
            offset: 0,
          })
        }
      }
    }

    fetchData()
  }, [])
  return (
    <div className={'md:py-8'}>
      <CarsBox
        customers={customers}
        car_models={car_models}
        cars={cars}
        setCars={setCars}
        setLazyLoadData={setLazyLoadData}
        lazy_load_data={lazy_load_data}
        customer_types={customer_types}
      />
    </div>
  )
}

export default memo(Cars)
